import { useCallback } from "react";
import { useNavStore } from "@/betby/store/navStore";
import { useNewOrderStore } from "@/betby/store/newOrderStore";

interface UseHeaderViewModelOptions {
  onBack?: () => void;
}

export function useHeaderViewModel({ onBack }: UseHeaderViewModelOptions) {
  const currentMode = useNavStore((state) => state.currentMode);
  const balances = useNavStore((state) => state.balances);
  const isOrderListVisible = useNavStore((state) => state.isOrderListVisible);
  const hideOrderList = useNavStore((state) => state.hideOrderList);
  const clearAllNewOrders = useNewOrderStore((state) => state.clearAll);

  const handleBackClick = useCallback(() => {
    if (isOrderListVisible) {
      hideOrderList();
      clearAllNewOrders();
      return;
    }

    onBack?.();
  }, [clearAllNewOrders, hideOrderList, isOrderListVisible, onBack]);

  return {
    currentMode: localStorage.getItem("winburst-mode") || currentMode,
    currentBalance: balances[currentMode],
    handleBackClick,
  };
}
